import { storybookReady } from '../../../core/js/utils'

let storybook, modal, form

(async function () {

  storybook = await storybookReady()

  modal = document.querySelector('.Modal')
  form = modal && modal.querySelector('form')

  let modalClose = modal && modal.querySelector('.Modal__Close')
  modalClose && modalClose.addEventListener('click', event => {
    delete modal.dataset.visible
  })
})()

export function loggedIn(value) {
  if (!window.ePitti) {
    return false
  }
  if (typeof value !== 'undefined') {
    window.ePitti.loggedIn = value
  }
  return window.ePitti.loggedIn
}

export function loggedInPromise() {
  // console.log('loggedInPromise')
  return new Promise((resolve) => {

    if (storybook || loggedIn()) {
      resolve(true)
      return
    }

    let notAsync = (!form || (typeof form.dataset.async === 'undefined'))
    if (!notAsync) {
      let handler
      handler = (event) => {
        event.preventDefault()

        form.removeEventListener('submit', handler)

        submit(form).then(response => {
          // console.log('A', response)
          if (response.success) {
            useToken(form.action, response.token).then(response2 => {
              delete modal.dataset.visible
              // console.log('B', response2)
              if (loggedIn(response2)) {
                headerUser(form.action)

                document.dispatchEvent(new CustomEvent('loggedIn', {
                  detail: {
                  }
                }))

                resolve(true)
              }
            })
          }
        })

      }
      form.addEventListener('submit', handler)
    }

    if (modal) {
      modal.dataset.visible = true
    }

    if (notAsync) {
      resolve(false)
      return
    }
  })
}

function submit(form) {
  return new Promise((resolve) => {
    fetch(form.action + '?async=true', {
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(new FormData(form)).toString()
    })
    .then(response => {
      if (response.status === 200) {
        return response.json()
      } else {
        throw new Error("Not 200 response")
      }
    })
    .then(json => {
      resolve(json)
    })
  })
}

function useToken(pathname, token) {
  return new Promise((resolve) => {
    fetch(pathname + '?usetoken=true&tokendaauthenticator=' + encodeURIComponent(token) + '&noredirect=true', {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    })
    .then(response => {
      if (response.status === 200) {
        return response.json()
      } else {
        throw new Error("Not 200 response")
      }
    })
    .then(json => {
      resolve(json)
    })
  })
}

function headerUser(pathname) {
  // console.log('headerUserPromise')
  fetch(pathname + '?headeruser=true', {
    credentials: 'same-origin',
    method: 'GET',
    headers: {
      Accept: 'text/html'
    }
  })
  .then(response => {
    if (response.status === 200) {
      return response.text()
    } else {
      throw new Error("Not 200 response")
    }
  })
  .then(text => {
    document.querySelector('.Header__User').outerHTML = text
  })
}
